import * as http from '~/utils/apis';

const userApi = {
    getAll: async (params) => {
        const res = await http.get(`cms-api/user-google-billings`, params);
        if (res) {
            const rows = res.data.data;
            const totalRows = res.data.total;
            return { rows, totalRows };
        }
    },
};

export default userApi;